/*eslint-disable*/
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink, useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import RTLNavbarLinks from "components/Navbars/RTLNavbarLinks.js";

import IconExpandLess from "@material-ui/icons/ExpandLess";
import IconExpandMore from "@material-ui/icons/ExpandMore";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Collapse from "@material-ui/core/Collapse";

import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";
import { useDot } from "../../context/automatonContext";
import { useUser } from "../../context/userContext";
import { useGrammar } from "context/grammarContext";
import { useLoading } from "../../context/Feedback/loadingContext";
import { useAlert } from "../../context/Feedback/alertContext";
import DOT from "../../components/MachineElement/DOT";
import validations from "../../utils/validationsMachine";
import DataService from "services/DataService";
import constantsValidate from "../../constants/Feedback/validationAutomata";
import constants from "../../constants/sideBarOptions";
import constantsNavbar from "../../constants/navbarOptions";
import constantsAutomaton from "../../constants/alertsInputAutomaton";
import automatonIcon from "../../assets/img/LogoAutomato 1.png";
import grammarIcon from "../../assets/img/LogoGrammar.png";
import frameworks from "assets/img/frameworks.svg";
import { useRouteName } from "hooks";
import "./style.css";
import { padding } from "@mui/system";
import { formatBackDate } from "../../utils/Formatter";

const useStyles = makeStyles(styles);

const useStylesButton = makeStyles(() => ({
  root: {
    backgroundColor: "transparent",
    "&:hover": {
      background: "transparent",
    },
    cursor: "not-allowed",
    color: "black",
  },

  // enable: {
  //   root: {
  //     backgroundColor: "transparent",
  //     "&:hover": {
  //       background: "transparent",
  //     },
  //     cursor: "not-allowed",
  //   },
  // },
}));

export default function Sidebar(props) {
  // let location = useLocation();
  const history = useHistory();
  const classes = useStyles();
  const classesBtn = useStylesButton();

  const [open, setOpen] = React.useState(false);
  const [complete, setComplete] = React.useState(false);
  const [openGrammar, setOpenGrammar] = React.useState(false);
  const {
    language,
    credential,
    user,
    setUser,
    setActiveTutorial,
    setCredential,
    isAuth,
    isAdmin,
    setIsAdmin,
  } = useUser();
  const { setAlert, setActiveAtentionClass, activeAtentionClass } = useAlert();
  const {
    setActiveDialogHowToUseGrammar,
    setActiveDialogHistoricalGrammar,
    setActiveDialogImportGrammar,
  } = useGrammar();
  const routeName = useRouteName();
  const [validMachine, setValidMachine] = useState(false);
  const {
    dot,
    setDot,
    createdDate,
    dotName,
    setDotName,
    setCreatedDate,
    setDrawableDot,
    setCurrentAlgorithm,
    arrayElements,
    setActiveDialogRegex,
    machineStates,
    machineTransitions,
    setMachineTransitionsResponse,
    setMachineStatesResponse,
    setResponseAFNDLambda,
    setResponseTableAFNDLambda,
    setResponseTableAFND,
    setResponseTableAFD,
    setResponseTableMinimization,
    setAfndDot,
    setActiveDialogImportDot,
    setActiveDialogHistorical,
    setActiveDialogSimulate,
    setResponseSimulate,
  } = useDot();
  const { setLoading } = useLoading();

  function handleClick() {
    if (activeAtentionClass != "vibrar") {
      setActiveAtentionClass("vibrar");
      setTimeout(() => {
        setActiveAtentionClass("");
      }, 5000);
    }
    if (!open && openGrammar) {
      setOpenGrammar(!openGrammar);
    }
    setOpen(!open);
  }
  function handleClickGrammar() {
    if (activeAtentionClass != "vibrar") {
      setActiveAtentionClass("vibrar");
      setTimeout(() => {
        setActiveAtentionClass("");
      }, 5000);
    }
    if (!openGrammar && open) {
      setOpen(!open);
    }
    setOpenGrammar(!openGrammar);
  }

  const toDotLanguage = () => {
    let dot = new DOT(machineStates, machineTransitions);

    dot.toDotLanguage();

    let string = dot.toString();
    // setDot(string);
    return string;
  };
  useEffect(() => {
    let dot = new DOT(machineStates, machineTransitions);
    dot.toDotLanguage();
    const string = dot.toString();
    setValidMachine(validations.isValidMachine(string).valid);
  }, [machineStates, machineTransitions]);

  const beforeSucceedAlgorithm = () => {
    setMachineTransitionsResponse([]);
    setMachineStatesResponse([]);
  };

  function verifyMachineName() {
    if (!dotName || dotName === "") {
      setAlert({
        active: true,
        text: constantsNavbar.alerts.info.defaultName[language],
        color: "warning",
        severity: "info",
      });
      const dateNow = new Date();
      setDotName(formatDate(dateNow));
      return;
    }
    const nameExists = user.historicalMachine.some(
      (machine) =>
        machine.name === dotName && machine.createdDate !== createdDate
    );

    if (nameExists) {
      setAlert({
        active: true,
        text: constantsNavbar.alerts.info.nameInUse[language],
        color: "danger",
        severity: "error",
      });
      return false;
    }

    return true;
  }
  async function handleSubmitCompleteAutomaton() {
    let data;
    try {
      if (!verifyMachineName()) {
        return;
      }

      data = toDotLanguage();
      setLoading(true);
      setDrawableDot("");
      resetTables();
      const isValid = validations.isValidMachine(data);
      if (isValid.valid) {
        const headers = {
          Authorization: credential,
        };
        const isComplete = await DataService.seeIfCompleteAutomaton(data, {
          headers,
        });
        if (!isComplete.data) {
          const response = await DataService.createCompleteAutomaton(data, {
            headers: {
              Authorization: credential,
            },
          });
          setCurrentAlgorithm("complete");
          beforeSucceedAlgorithm();
          setDrawableDot(response.data);
          setComplete(true);
          afterSucceedSubmitAutomaton(data);
          history.push("/user/responseAutomaton");
        } else {
          setAlert({
            active: true,
            text: constantsAutomaton.infos.complete[language],
            color: "info",
            sevarity: "info",
            // icon: ErrorIcon,
          });
        }
        setDot(data);
      } else {
        setAlert({
          active: true,
          text:
            isValid.message[language] +
            ", " +
            constantsValidate.validMachine.error.afterMessage[language],
          color: "info",
          sevarity: "info",
          // icon: ErrorIcon,
        });
        if (isValid.validationError === 1) {
          setDot("");
        }
      }

      setLoading(false);
    } catch (e) {
      setLoading(false);
      setDot(data);
      alert(e);
    }
  }
  async function handleSubmitConvertAFNDToAFDAutomaton() {
    try {
      if (!verifyMachineName()) {
        return;
      }
      const headers = {
        Authorization: credential,
      };
      const data = toDotLanguage();
      setLoading(true);
      setDrawableDot("");
      resetTables();
      const isValid = validations.isValidMachine(data);
      if (isValid.valid) {
        const isAFDAutomaton = await DataService.seeIfAFDAutomaton(data, {
          headers,
        });

        if (!isAFDAutomaton.data) {
          setResponseAFNDLambda(data);
          const isAFNDLambdaAutomaton = await DataService.seeIfAFNDLambdaAutomaton(
            data,
            { headers }
          );
          if (isAFNDLambdaAutomaton.data) {
            const responseAFNDLambdaTable = await DataService.getTransitionTableAFNDLambda(
              data,
              {
                headers: {
                  Authorization: credential,
                },
              }
            );
            setResponseTableAFNDLambda(responseAFNDLambdaTable);
            const AFNDAutomaton = await DataService.convertAFNDLambdaToAFND(
              data,
              {
                headers,
              }
            );
            setAfndDot(AFNDAutomaton.data);
            const responseAFNDTable = await DataService.getTransitionTableAFND(
              AFNDAutomaton.data,
              {
                headers: {
                  Authorization: credential,
                },
              }
            );

            setResponseTableAFND(responseAFNDTable);
            const AFDAutomaton = await DataService.convertAFNDtoAFD(
              AFNDAutomaton.data,
              {
                headers,
              }
            );
            const responseAFDTable = await DataService.getTransitionTableAFD(
              AFDAutomaton.data,
              {
                headers: {
                  Authorization: credential,
                },
              }
            );
            beforeSucceedAlgorithm();
            setResponseTableAFD(responseAFDTable);
            setDrawableDot(AFDAutomaton.data);
            setComplete(true);
            setDot(data);
          } else {
            const AFDAutomaton = await DataService.convertAFNDtoAFD(data, {
              headers,
            });
            const responseAFNDTable = await DataService.getTransitionTableAFND(
              data,
              {
                headers: {
                  Authorization: credential,
                },
              }
            );
            beforeSucceedAlgorithm();
            setResponseTableAFND(responseAFNDTable);
            setAfndDot(data);
            const responseAFDTable = await DataService.getTransitionTableAFD(
              AFDAutomaton.data,
              {
                headers: {
                  Authorization: credential,
                },
              }
            );
            setResponseTableAFD(responseAFDTable);
            setDrawableDot(AFDAutomaton.data);
          }
          history.push("/user/responseAutomaton");
        } else {
          setAlert({
            active: true,
            text: constantsAutomaton.infos.AFD[language],
            color: "info",
            sevarity: "info",
            // icon: ErrorIcon,
          });
        }

        setCurrentAlgorithm("convertNFDAtoFDA");
        setComplete(true);
        setDot(data);
        afterSucceedSubmitAutomaton(data);
      } else {
        setDot("");

        setAlert({
          active: true,
          text:
            isValid.message[language] +
            ", " +
            constantsValidate.validMachine.error.afterMessage[language],
          color: "info",
          sevarity: "info",
          // icon: ErrorIcon,
        });
      }
      setLoading(false);
      // location.href = "/admin/responseAutomaton";
    } catch (e) {
      alert(e);
      setLoading(false);
    }
  }
  async function handleSubmitMinimizationAutomaton() {
    let data;
    try {
      data = toDotLanguage();
      setLoading(true);
      setDrawableDot("");
      resetTables();
      const isValid = validations.isValidMachine(data);
      if (isValid.valid) {
        const isCompleteAutomaton = await DataService.seeIfCompleteAutomaton(
          data,
          {
            headers: {
              Authorization: credential,
            },
          }
        );
        if (isCompleteAutomaton.data) {
          const response = await DataService.getMinimazeAutomaton(data, {
            headers: {
              Authorization: credential,
            },
          });
          const tableMinimization = await DataService.getTableMinimization(
            data,
            {
              headers: {
                Authorization: credential,
              },
            }
          );
          beforeSucceedAlgorithm();
          setResponseTableMinimization(tableMinimization);
          setDrawableDot(response.data);
          setComplete(true);
          afterSucceedSubmitAutomaton(data);
          setDot(data);
          setCurrentAlgorithm("minimize");
          history.push("/user/responseAutomaton");
        } else {
          setAlert({
            active: true,
            text: constantsAutomaton.infos.needIsComplete[language],
            color: "info",
            sevarity: "info",
            // icon: ErrorIcon,
          });
        }
      } else {
        setDot("");

        setAlert({
          active: true,
          text:
            isValid.message[language] +
            ", " +
            constantsValidate.validMachine.error.afterMessage[language],
          color: "info",
          sevarity: "info",
          // icon: ErrorIcon,
        });
      }
    } catch (e) {
      alert(e);
    }
    setLoading(false);
  }
  function resetTables() {
    setResponseAFNDLambda({});
    setResponseTableAFNDLambda({});
    setResponseTableAFND({});
    setResponseTableAFD({});
    setResponseTableMinimization({});
    setResponseSimulate({});
  }

  const formatDate = (date) => {
    const pad = (num) => String(num).padStart(2, "0");

    const d = pad(date.getDate());
    const m = pad(date.getMonth() + 1);
    const y = date.getFullYear();
    const hh = pad(date.getHours());
    const mm = pad(date.getMinutes());
    const ss = pad(date.getSeconds());

    return `${d}/${m}/${y}-${hh}:${mm}:${ss}`;
  };

  function nameExistsInList(list, name, ignoreCreatedDate) {
    return list.some(
      (item) => item.name === name && item.createdDate !== ignoreCreatedDate
    );
  }

  function verifyCreatedDate(list, dateToVerify) {
    return list.findIndex((item) => item.createdDate === dateToVerify);
  }
  /**
   * Processa a submissão bem-sucedida de uma automação e atualiza ou cria um histórico da máquina do usuário.
   *
   * @param {Object} dot - Variáveis da máquina que serão salvas ou atualizadas no histórico.
   * @throws {Error} Lança um erro caso ocorra uma falha na requisição ou processamento dos dados.
   *
   * O funcionamento do método:
   * - Verifica se já existe um histórico da máquina com a mesma `createdDate`.
   * - Se existir, atualiza o histórico existente chamando `DataService.updateHistoricalMc`.
   * - Se não existir, cria um novo histórico chamando `DataService.postSaveHistoricalMc`.
   * - Após a requisição bem-sucedida, atualiza `user.historicalMachine` e define `setCreatedDate`.
   * - Exibe um alerta ao usuário indicando se a máquina foi criada ou atualizada com sucesso.
   */
  async function afterSucceedSubmitAutomaton(dot) {
    try {
      if (!dotName) {
        setAlert({
          active: true,
          text: constantsNavbar.alerts.info.defaultName[language],
          color: "warning",
          severity: "info",
        });
        setDotName(formatDate(new Date()));
      }

      const authorization = {
        headers: { Authorization: credential },
      };

      const param = {
        variables: dot,
        name: dotName,
      };

      const existingIndex = verifyCreatedDate(
        user.historicalMachine,
        createdDate
      );

      if (
        existingIndex !== -1 &&
        nameExistsInList(user.historicalMachine, dotName, createdDate)
      ) {
        setAlert({
          active: true,
          text: constantsNavbar.alerts.info.nameInUse[language],
          color: "danger",
          severity: "error",
        });
        return;
      }

      const dateNow = new Date().toISOString();

      if (existingIndex !== -1) {
        const updateResponse = await DataService.updateHistoricalMc(
          user.email,
          param,
          formatBackDate(createdDate),
          authorization
        );

        setUser((prevUser) => {
          const updatedHistoricalMachine = prevUser.historicalMachine.map(
            (entry) => {
              if (entry.createdDate === createdDate) {
                return {
                  ...entry,
                  variables: dot,
                  lastUpdatedDate: dateNow,
                  createdDate: updateResponse.data.createdDate,
                  name: updateResponse.data.name,
                };
              } else {
                return entry;
              }
            }
          );

          return { ...prevUser, historicalMachine: updatedHistoricalMachine };
        });

        setCreatedDate(updateResponse.data.createdDate);
        setDotName(updateResponse.data.name);
        setAlert({
          active: true,
          text: constantsAutomaton.infos.updated[language],
          color: "success",
        });
      } else {
        const saveResponse = await DataService.postSaveHistoricalMc(
          user.email,
          param,
          authorization
        );

        const formattedCreatedDate = saveResponse.data.createdDate.slice(0, 23);

        setUser((prevUser) => {
          const updatedHistoricalMachine = [
            {
              variables: dot,
              lastUpdatedDate: dateNow,
              createdDate: formattedCreatedDate,
              name: saveResponse.data.name,
            },
            ...prevUser.historicalMachine,
          ];

          return { ...prevUser, historicalMachine: updatedHistoricalMachine };
        });

        setCreatedDate(formattedCreatedDate);
        setDotName(saveResponse.data.name);
        setAlert({
          active: true,
          text: constantsAutomaton.infos.create[language],
          color: "success",
        });
      }
    } catch (e) {
      console.error("Error submitting automaton:", e);
      alert(e);
    }
  }

  function handleOpenDialogImportDot() {
    setActiveDialogImportDot(true);
  }
  function handleOpenDialogHistorical() {
    setActiveDialogHistorical(true);
  }
  function handleOpenDialogRegex() {
    setActiveDialogRegex(true);
  }
  function activeRoute(routeName) {
    return location.pathname === routeName;
  }
  function returnRouterTo() {
    if (routeName === "Draw" && validMachine) {
      return "/user/responseAutomaton";
    } else {
      return "/user/automaton";
    }
  }
  function handleOpenDialogHistoricalGrammar() {
    setActiveDialogHistoricalGrammar(true);
  }
  function handleChangeRoute(route) {
    if (route == "grammar") {
      handleClickGrammar();
    } else if (route == "automaton") {
      handleClick();
    }
    if (isAuth) {
      history.push("/user/" + route);
    }
  }

  function handleOpenDialogImportGrammar() {
    setActiveDialogImportGrammar(true);
  }

  function handleHowToUseGrammarDialog() {
    setActiveDialogHowToUseGrammar(true);
  }

  const { logo, image } = props;

  var links = (
    <List>
      <ListItem
        button
        className={classNames(classes.itemText, classes.button, {
          [classes.itemTextRTL]: props.rtlActive,
        })}
      >
        <ListItemIcon>
          <div
            style={{
              width: 50,
              display: "flex",
              alignItems: "center",
              minHeight: 61,
            }}
          >
            <svg
              style={{ width: "100%" }}
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path
                fill="#252536"
                d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z"
              />
            </svg>
          </div>
        </ListItemIcon>
        <ListItemText
          onClick={() => {
            handleChangeRoute("about");
          }}
          primary={constants.buttonRouter.theProject[language]}
        />
      </ListItem>
      <ListItem
        button
        className={classNames(classes.itemText, classes.button, {
          [classes.itemTextRTL]: props.rtlActive,
        })}
        onClick={() => {
          handleChangeRoute("grammar");
        }}
      >
        {/* <NavLink to="/user/grammar"> */}
        <ListItemIcon
          // className={classes.menuItemIcon}
          onClick={() => {
            handleChangeRoute("grammar");
          }}
        >
          <div
            style={{
              width: 50,
            }}
          >
            <img
              title={constants.buttonRouter.grammar[language]}
              style={{ width: "100%" }}
              src={grammarIcon}
            />
          </div>
        </ListItemIcon>

        <ListItemText
          onClick={() => {
            handleChangeRoute("grammar");
          }}
          primary={constants.label.grammar[language]}
        />
        {/* </NavLink> */}
        {openGrammar ? (
          <IconExpandLess onClick={handleClickGrammar} />
        ) : (
          <IconExpandMore onClick={handleClickGrammar} />
        )}
      </ListItem>
      <Collapse in={openGrammar} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <List component="div" disablePadding>
            <div className={classes.wrapperList}>
              <ListItem
                button
                onClick={() => {
                  isAuth
                    ? handleOpenDialogImportGrammar()
                    : window.open("/login", "_self");
                }}
                // disabled={
                //   isAuth ? (routeName === "grammar" ? false : true) : true
                // }
                className={classNames(classes.itemText, classes.button, {
                  [classes.itemTextRTL]: props.rtlActive,
                })}
              >
                <ListItemText
                  inset
                  primary={constants.algorithms.importGrammar[language]}
                />
              </ListItem>
            </div>
          </List>

          <div className={classes.wrapperList}>
            <ListItem
              button
              // className={classNames(
              //   classesBtn.root,
              //   classes.itemText,
              //   classes.button,
              //   {
              //     [classes.itemTextRTL]: props.rtlActive,
              //   }
              // )}
              onClick={() => {
                isAuth
                  ? handleOpenDialogHistoricalGrammar()
                  : window.open("/login", "_self");
              }}
              // disabled={
              //   isAuth ? (routeName === "grammar" ? false : true) : true
              // }
              className={classNames(classes.itemText, classes.button, {
                [classes.itemTextRTL]: props.rtlActive,
              })}
            >
              <ListItemText inset primary={constants.historic[language]} />
            </ListItem>
          </div>
          <div className={classes.wrapperList}>
            <ListItem
              onClick={() => {
                handleHowToUseGrammarDialog();
              }}
              button
              disabled={
                isAuth ? (routeName === "grammar" ? false : true) : true
              }
              className={classNames(classes.itemText, classes.button, {
                [classes.itemTextRTL]: props.rtlActive,
              })}
            >
              <ListItemText inset primary={constants.howToUse[language]} />
            </ListItem>
          </div>
        </List>
      </Collapse>
      <ListItem
        button
        className={classNames(classes.itemText, classes.button, {
          [classes.itemTextRTL]: props.rtlActive,
        })}
        onClick={() => {
          handleChangeRoute("automaton");
        }}
      >
        <ListItemIcon
          onClick={() => {
            handleChangeRoute("automaton");
          }}
        >
          {/* <NavLink to="/user/automaton"> */}

          <div
            style={{
              width: 50,
            }}
          >
            <img
              title={constants.buttonRouter.machine[language]}
              style={{ width: "100%" }}
              src={automatonIcon}
            />
          </div>

          {/* </NavLink> */}
        </ListItemIcon>

        <ListItemText
          onClick={() => {
            handleChangeRoute("automaton");
          }}
          primary={constants.label.machine[language]}
        />
        {open ? (
          <IconExpandLess onClick={handleClick} />
        ) : (
          <IconExpandMore onClick={handleClick} />
        )}
      </ListItem>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <div className={classes.wrapperList}>
            <ListItem
              button
              className={classNames(
                !validMachine && classesBtn.root,
                classes.itemText,
                classes.button,
                {
                  [classes.itemTextRTL]: props.rtlActive,
                }
              )}
              // disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
              onClick={() => {
                isAuth
                  ? handleSubmitCompleteAutomaton()
                  : window.open("/login", "_self");
              }}
            >
              <ListItemText
                className={classNames(!validMachine && classesBtn.root)}
                inset
                primary={constants.algorithms.complete[language]}
              />
            </ListItem>
            <ListItem
              button
              disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
              // className="bt-afnd"
              className={classNames(
                !validMachine && classesBtn.root,
                classes.itemText,
                classes.button,
                {
                  [classes.itemTextRTL]: props.rtlActive,
                }
              )}
              onClick={() => {
                handleSubmitConvertAFNDToAFDAutomaton();
              }}
            >
              <ListItemText
                className={classNames(!validMachine && classesBtn.root)}
                inset
                primary={constants.algorithms.convertAFNDToAFD[language]}
              />
            </ListItem>
            <ListItem
              button
              className={classNames(
                !validMachine && classesBtn.root,
                classes.itemText,
                classes.button,
                {
                  [classes.itemTextRTL]: props.rtlActive,
                }
              )}
              disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
              onClick={() => {
                handleSubmitMinimizationAutomaton();
              }}
            >
              <ListItemText
                className={classNames(!validMachine && classesBtn.root)}
                inset
                primary={constants.algorithms.minimizar[language]}
              />
            </ListItem>
            <ListItem
              onClick={() => {
                handleOpenDialogRegex();
              }}
              disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
              button
              className={classNames(classes.itemText, classes.button, {
                [classes.itemTextRTL]: props.rtlActive,
              })}
            >
              <ListItemText
                inset
                primary={constants.algorithms.regextToAutomata[language]}
              />
            </ListItem>
            <ListItem
              button
              disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
              className={classNames(
                !validMachine && classesBtn.root,
                classes.itemText,
                classes.button,
                {
                  [classes.itemTextRTL]: props.rtlActive,
                }
              )}
              onClick={() => {
                setActiveDialogSimulate(true);
              }}
              // disabled={routeName === "Draw" ? false : true}
            >
              <ListItemText
                className={classNames(!validMachine && classesBtn.root)}
                inset
                primary={constants.algorithms.simulate[language]}
              />
            </ListItem>
            <ListItem
              onClick={() => {
                handleOpenDialogImportDot();
              }}
              disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
              button
              className={classNames(classes.itemText, classes.button, {
                [classes.itemTextRTL]: props.rtlActive,
              })}
            >
              <ListItemText
                inset
                primary={constants.algorithms.importDot[language]}
              />
            </ListItem>
            <ListItem
              onClick={() => {
                setActiveTutorial(true);
              }}
              disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
              button
              className={classNames(classes.itemText, classes.button, {
                [classes.itemTextRTL]: props.rtlActive,
              })}
            >
              <ListItemText inset primary={constants.howToUse[language]} />
            </ListItem>
            <ListItem
              onClick={() => {
                handleOpenDialogHistorical();
              }}
              button
              disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
              className={classNames(classes.itemText, classes.button, {
                [classes.itemTextRTL]: props.rtlActive,
              })}
            >
              <ListItemText inset primary={constants.historic[language]} />
            </ListItem>
          </div>
        </List>
      </Collapse>
      {isAdmin && (
        <ListItem
          button
          className={classNames(classes.itemText, classes.button, {
            [classes.itemTextRTL]: props.rtlActive,
          })}
        >
          <ListItemIcon>
            <div
              style={{
                width: 50,
                display: "flex",
                alignItems: "center",
                minHeight: 61,
              }}
            >
              <svg
                fill="#000000"
                xmlns="http://www.w3.org/2000/svg"
                style={{ width: "100%" }}
                width="40"
                height="40"
                viewBox="0 0 128 128"
              >
                <path d="M 33.5 9 C 26.3 9 20.5 14.8 20.5 22 L 20.5 102 C 20.5 109.2 26.3 115 33.5 115 L 94.5 115 C 101.7 115 107.5 109.2 107.5 102 L 107.5 22 C 107.5 14.8 101.7 9 94.5 9 L 33.5 9 z M 33.5 15 L 94.5 15 C 98.4 15 101.5 18.1 101.5 22 L 101.5 102 C 101.5 105.9 98.4 109 94.5 109 L 33.5 109 C 29.6 109 26.5 105.9 26.5 102 L 26.5 22 C 26.5 18.1 29.6 15 33.5 15 z M 33.5 22 L 33.5 37 L 94.5 37 L 94.5 22 L 33.5 22 z M 37.5 51 C 35.8 51 34.5 52.3 34.5 54 C 34.5 55.7 35.8 57 37.5 57 L 88.5 57 C 90.2 57 91.5 55.7 91.5 54 C 91.5 52.3 90.2 51 88.5 51 L 37.5 51 z M 37.5 66 C 35.8 66 34.5 67.3 34.5 69 C 34.5 70.7 35.8 72 37.5 72 L 88.5 72 C 90.2 72 91.5 70.7 91.5 69 C 91.5 67.3 90.2 66 88.5 66 L 37.5 66 z M 37.5 81 C 35.8 81 34.5 82.3 34.5 84 C 34.5 85.7 35.8 87 37.5 87 L 64 87 C 65.7 87 67 85.7 67 84 C 67 82.3 65.7 81 64 81 L 37.5 81 z" />
              </svg>
            </div>
          </ListItemIcon>
          <ListItemText
            onClick={() => {
              handleChangeRoute("reports");
            }}
            primary={constants.buttonRouter.report[language]}
          />
        </ListItem>
      )}
    </List>
  );
  var brand = (
    <div className={classes.logo}>
      <a
        href="/user/automaton"
        className={classNames(classes.logoLink, {
          [classes.logoLinkRTL]: props.rtlActive,
        })}
      >
        <div className={classes.logoImage}>
          <img src={logo} alt="logo" className={classes.img} />
        </div>
        {/* {logoText} */}
      </a>
    </div>
  );
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const id = open ? "simple-popover" : undefined;
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={props.rtlActive ? "left" : "right"}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive,
            }),
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            {props.rtlActive ? <RTLNavbarLinks /> : <AdminNavbarLinks />}
            {links}
          </div>
          {/* {image !== undefined ? <div className={classes.background} /> : null} */}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        {/* sidebar propriamente dita */}
        <Drawer
          anchor={props.rtlActive ? "right" : "left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive,
            }),
          }}
        >
          {brand}
          <div className={` ${classes.sidebarWrapper}`}>
            {links}
            <div className="footer-sidebar">
              <List
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <ListItem
                  style={{ whiteSpace: "nowrap", padding: 0 }}
                  className={(classes.inlineBlock, classes.block)}
                >
                  {constants.version[language]}: 2.5.0
                </ListItem>
                <ListItem>
                  <img alt="" src={frameworks} width="65" />
                </ListItem>
              </List>
            </div>
          </div>
          {image !== undefined ? (
            <div
              className={`testee ${classes.background}`}
              // style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool,
};
